import { Component, Input } from '@angular/core';
import { IListItem } from '../../models';

@Component({
  selector: 'lib-list',
  templateUrl: './list.component.html',
})
export class ListComponent {
  @Input() list!: IListItem[];

  trackByFn(index: any) {
    return index;
  }
}
